import { render, staticRenderFns } from "./detail - 副本 (2).vue?vue&type=template&id=18442fd4&scoped=true"
import script from "./detail - 副本 (2).vue?vue&type=script&lang=js"
export * from "./detail - 副本 (2).vue?vue&type=script&lang=js"
import style0 from "./detail - 副本 (2).vue?vue&type=style&index=0&id=18442fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18442fd4",
  null
  
)

export default component.exports